import React from "react";
import Swal from "sweetalert2";
import { updateClientTestimonial } from "../../api/ClientTestimonial";

const EditClientTestimonial = ({ clientTestimonial, onSuccess }) => {
  const [clientTestimonialDetails, setClientTestimonialDetails] =
    React.useState({
      id: "",
      name: "",
      rating: "",
      message: "",
    });

  React.useEffect(() => {
    setClientTestimonialDetails({
      id: clientTestimonial?._id,
      name: clientTestimonial?.name,
      rating: clientTestimonial?.rating,
      message: clientTestimonial?.message,
    });
  }, [clientTestimonial]);

  const handleSubmit = (e) => {
    e.preventDefault();
    const response = updateClientTestimonial(clientTestimonialDetails);
    response
      .then((res) => {
        if (res.status === 200) {
          Swal.fire({
            title: "Client Testimonial Updated!",
            text: "You have successfully updated a client testimonial!",
            icon: "success",
            draggable: true,
            timer: 1000,
          });
          onSuccess(res);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      <form className="text-left" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="exampleInputName">Name</label>
          <input
            type="text"
            className="form-control"
            name="name"
            value={clientTestimonialDetails.name}
            onChange={(e) =>
              setClientTestimonialDetails({
                ...clientTestimonialDetails,
                id: clientTestimonialDetails?.id,
                name: e.target.value,
              })
            }
          />
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputIntroduction">Rating</label>
          <div class="starrating risingstar d-flex justify-content-end flex-row-reverse">
            <input
              type="radio"
              id="star5"
              name="rating"
              value={clientTestimonialDetails.rating}
              onChange={(e) =>
                setClientTestimonialDetails({
                  ...clientTestimonialDetails,
                  id: clientTestimonialDetails?.id,
                  rating: e.target.value,
                })
              }
            />
            <label for="star5" title="5 star">
              5
            </label>
            <input
              type="radio"
              id="star4"
              name="rating"
              value={clientTestimonialDetails.rating}
              onChange={(e) =>
                setClientTestimonialDetails({
                  ...clientTestimonialDetails,
                  id: clientTestimonialDetails?.id,
                  rating: e.target.value,
                })
              }
            />
            <label for="star4" title="4 star">
              4
            </label>
            <input
              type="radio"
              id="star3"
              name="rating"
              value={clientTestimonialDetails.rating}
              onChange={(e) =>
                setClientTestimonialDetails({
                  ...clientTestimonialDetails,
                  id: clientTestimonialDetails?.id,
                  rating: e.target.value,
                })
              }
            />
            <label for="star3" title="3 star">
              3
            </label>
            <input
              type="radio"
              id="star2"
              name="rating"
              value={clientTestimonialDetails.rating}
              onChange={(e) =>
                setClientTestimonialDetails({
                  ...clientTestimonialDetails,
                  id: clientTestimonialDetails?.id,
                  rating: e.target.value,
                })
              }
            />
            <label for="star2" title="2 star">
              2
            </label>
            <input
              type="radio"
              id="star1"
              name="rating"
              value={clientTestimonialDetails.rating}
              onChange={(e) =>
                setClientTestimonialDetails({
                  ...clientTestimonialDetails,
                  id: clientTestimonialDetails?.id,
                  rating: e.target.value,
                })
              }
            />
            <label for="star1" title="1 star">
              1
            </label>
          </div>
        </div>
        <div className="form-group">
          <label htmlFor="exampleInputMessage">Message</label>
          <textarea
            className="form-control"
            id="exampleInputMessage"
            rows="3"
            value={clientTestimonialDetails.message}
            onChange={(e) =>
              setClientTestimonialDetails({
                ...clientTestimonialDetails,
                id: clientTestimonialDetails?.id,
                message: e.target.value,
              })
            }
          ></textarea>
        </div>
        <button type="submit" className="btn btn-primary text-right">
          Update
        </button>
      </form>
    </>
  );
};

export default EditClientTestimonial;
